import { render, staticRenderFns } from "./AdminUserBalanceWithdraw.vue?vue&type=template&id=48135276&scoped=true&"
import script from "./AdminUserBalanceWithdraw.vue?vue&type=script&lang=ts&"
export * from "./AdminUserBalanceWithdraw.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserBalanceWithdraw.vue?vue&type=style&index=0&id=48135276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48135276",
  null
  
)

export default component.exports